// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".EcommerceOrderStatusSection-section__meMad{display:flex;flex-direction:column;gap:var(--size-2)}.EcommerceOrderStatusSection-row__EwA54{display:flex;gap:var(--size-3);align-items:center;justify-content:space-between}.EcommerceOrderStatusSection-storeName__CqVgt{font-weight:var(--font-weight-medium)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": "EcommerceOrderStatusSection-section__meMad",
	"row": "EcommerceOrderStatusSection-row__EwA54",
	"storeName": "EcommerceOrderStatusSection-storeName__CqVgt"
};
export default ___CSS_LOADER_EXPORT___;
